export const Items: import('../../../sim/dex-items').ModdedItemDataTable = {
	aguavberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Dragon",
		},
	},
	apicotberry: {
		inherit: true,
		naturalGift: {
			basePower: 80,
			type: "Ground",
		},
	},
	aspearberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Ice",
		},
	},
	babiriberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Steel",
		},
	},
	belueberry: {
		inherit: true,
		naturalGift: {
			basePower: 80,
			type: "Electric",
		},
	},
	blukberry: {
		inherit: true,
		naturalGift: {
			basePower: 70,
			type: "Fire",
		},
	},
	buggem: {
		inherit: true,
		isNonstandard: null,
	},
	chartiberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Rock",
		},
	},
	cheriberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Fire",
		},
	},
	chestoberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Water",
		},
	},
	chilanberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Normal",
		},
	},
	chopleberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Fighting",
		},
	},
	cobaberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Flying",
		},
	},
	colburberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Dark",
		},
	},
	cornnberry: {
		inherit: true,
		naturalGift: {
			basePower: 70,
			type: "Bug",
		},
	},
	custapberry: {
		inherit: true,
		naturalGift: {
			basePower: 80,
			type: "Ghost",
		},
	},
	darkgem: {
		inherit: true,
		isNonstandard: null,
	},
	dragongem: {
		inherit: true,
		isNonstandard: null,
	},
	durinberry: {
		inherit: true,
		naturalGift: {
			basePower: 80,
			type: "Water",
		},
	},
	electricgem: {
		inherit: true,
		isNonstandard: null,
	},
	enigmaberry: {
		inherit: true,
		naturalGift: {
			basePower: 80,
			type: "Bug",
		},
	},
	fightinggem: {
		inherit: true,
		isNonstandard: null,
	},
	figyberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Bug",
		},
	},
	firegem: {
		inherit: true,
		isNonstandard: null,
	},
	flyinggem: {
		inherit: true,
		isNonstandard: null,
	},
	ganlonberry: {
		inherit: true,
		naturalGift: {
			basePower: 80,
			type: "Ice",
		},
	},
	ghostgem: {
		inherit: true,
		isNonstandard: null,
	},
	grassgem: {
		inherit: true,
		isNonstandard: null,
	},
	grepaberry: {
		inherit: true,
		naturalGift: {
			basePower: 70,
			type: "Flying",
		},
	},
	groundgem: {
		inherit: true,
		isNonstandard: null,
	},
	habanberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Dragon",
		},
	},
	hondewberry: {
		inherit: true,
		naturalGift: {
			basePower: 70,
			type: "Ground",
		},
	},
	iapapaberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Dark",
		},
	},
	icegem: {
		inherit: true,
		isNonstandard: null,
	},
	jabocaberry: {
		inherit: true,
		naturalGift: {
			basePower: 80,
			type: "Dragon",
		},
	},
	kasibberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Ghost",
		},
	},
	kebiaberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Poison",
		},
	},
	kelpsyberry: {
		inherit: true,
		naturalGift: {
			basePower: 70,
			type: "Fighting",
		},
	},
	lansatberry: {
		inherit: true,
		naturalGift: {
			basePower: 80,
			type: "Flying",
		},
	},
	leppaberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Fighting",
		},
	},
	liechiberry: {
		inherit: true,
		naturalGift: {
			basePower: 80,
			type: "Grass",
		},
	},
	lumberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Flying",
		},
	},
	mail: {
		inherit: true,
		isNonstandard: null,
	},
	magoberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Ghost",
		},
	},
	magostberry: {
		inherit: true,
		naturalGift: {
			basePower: 70,
			type: "Rock",
		},
	},
	micleberry: {
		inherit: true,
		naturalGift: {
			basePower: 80,
			type: "Rock",
		},
	},
	nanabberry: {
		inherit: true,
		naturalGift: {
			basePower: 70,
			type: "Water",
		},
	},
	nomelberry: {
		inherit: true,
		naturalGift: {
			basePower: 70,
			type: "Dragon",
		},
	},
	occaberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Fire",
		},
	},
	oranberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Poison",
		},
	},
	pamtreberry: {
		inherit: true,
		naturalGift: {
			basePower: 70,
			type: "Steel",
		},
	},
	passhoberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Water",
		},
	},
	payapaberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Psychic",
		},
	},
	pechaberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Electric",
		},
	},
	persimberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Ground",
		},
	},
	petayaberry: {
		inherit: true,
		naturalGift: {
			basePower: 80,
			type: "Poison",
		},
	},
	pinapberry: {
		inherit: true,
		naturalGift: {
			basePower: 70,
			type: "Grass",
		},
	},
	poisongem: {
		inherit: true,
		isNonstandard: null,
	},
	pomegberry: {
		inherit: true,
		naturalGift: {
			basePower: 70,
			type: "Ice",
		},
	},
	psychicgem: {
		inherit: true,
		isNonstandard: null,
	},
	qualotberry: {
		inherit: true,
		naturalGift: {
			basePower: 70,
			type: "Poison",
		},
	},
	rabutaberry: {
		inherit: true,
		naturalGift: {
			basePower: 70,
			type: "Ghost",
		},
	},
	rawstberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Grass",
		},
	},
	razzberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Steel",
		},
	},
	rindoberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Grass",
		},
	},
	rockgem: {
		inherit: true,
		isNonstandard: null,
	},
	rowapberry: {
		inherit: true,
		naturalGift: {
			basePower: 80,
			type: "Dark",
		},
	},
	salacberry: {
		inherit: true,
		naturalGift: {
			basePower: 80,
			type: "Fighting",
		},
	},
	shucaberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Ground",
		},
	},
	sitrusberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Psychic",
		},
	},
	spelonberry: {
		inherit: true,
		naturalGift: {
			basePower: 70,
			type: "Dark",
		},
	},
	starfberry: {
		inherit: true,
		naturalGift: {
			basePower: 80,
			type: "Psychic",
		},
	},
	steelgem: {
		inherit: true,
		isNonstandard: null,
	},
	tamatoberry: {
		inherit: true,
		naturalGift: {
			basePower: 70,
			type: "Psychic",
		},
	},
	tangaberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Bug",
		},
	},
	wacanberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Electric",
		},
	},
	watergem: {
		inherit: true,
		isNonstandard: null,
	},
	watmelberry: {
		inherit: true,
		naturalGift: {
			basePower: 80,
			type: "Fire",
		},
	},
	wepearberry: {
		inherit: true,
		naturalGift: {
			basePower: 70,
			type: "Electric",
		},
	},
	wikiberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Rock",
		},
	},
	yacheberry: {
		inherit: true,
		naturalGift: {
			basePower: 60,
			type: "Ice",
		},
	},
};
